import { makeAction } from '@va/store';

export const GET_PRIVACY_SETTINGS = 'GET_PRIVACY_SETTINGS';
export const GET_PRIVACY_SETTINGS_SUCCEEDED = 'GET_PRIVACY_SETTINGS_SUCCEEDED';
export const GET_PRIVACY_SETTINGS_FAILED = 'GET_PRIVACY_SETTINGS_FAILED';

export const getPrivacySettings = makeAction(GET_PRIVACY_SETTINGS);
export const getPrivacySettingsSucceeded = makeAction(GET_PRIVACY_SETTINGS_SUCCEEDED, 'data');
export const getPrivacySettingsFailed = makeAction(GET_PRIVACY_SETTINGS_FAILED, 'error');
